import { useContext, useCallback } from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';
import { AjaxContext, AppContext, UserContext } from 'commons-ui';

import { ACTION, PAGE_NAMES, USER_PROFILE_RESOURCES } from 'constant';
import { VIEW_FIELD_KEYS } from '../constants';

const useService = () => {
	const {
		app: { appName }
	} = useContext(AppContext);
	const { postData } = useContext(AjaxContext);
	const { permissionsConfig } = useContext(UserContext);
	const getRazorpayPayoutDetails = useCallback(async (tid: number) => {
		const permission = _find(permissionsConfig, { actionName: ACTION.getRazorpayPayoutDetails });
		const result = await postData({
			endpoint: `/dashboard/getRazorpayPayoutDetails/${PAGE_NAMES.userProfile}-${USER_PROFILE_RESOURCES.transactionHistory}-getRazorpayPayoutDetails`,
			queryParams: {
				appName
			},
			body: { tid },
			customHeaders: {
				isMasked: permission?.isMasked || false
			}
		});

		const data = _get(result, ['data', 'data']);
		return {
			[VIEW_FIELD_KEYS.RAZORPAY_PAYOUT_ID]: data[VIEW_FIELD_KEYS.RAZORPAY_PAYOUT_ID],
			[VIEW_FIELD_KEYS.RAZORPAY_PAYOUT_MSG]: data[VIEW_FIELD_KEYS.RAZORPAY_PAYOUT_MSG]
		};
	}, []);

	return {
		getRazorpayPayoutDetails
	};
};

export default useService;
